import { render, staticRenderFns } from "./KidjoFooter.vue?vue&type=template&id=09b221d6&scoped=true"
import script from "./KidjoFooter.vue?vue&type=script&lang=js"
export * from "./KidjoFooter.vue?vue&type=script&lang=js"
import style0 from "./KidjoFooter.vue?vue&type=style&index=0&id=09b221d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b221d6",
  null
  
)

export default component.exports